import React from "react";

class ShortStory extends React.Component {
	render() {
		return (
			<div className="ShortStory" id="background">
				<p>{this.props.text}</p>
			</div>
		);
	}
}

export default ShortStory;



// WEBPACK FOOTER //
// ./src/components/ShortStory.js